import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import AddVideo from 'components/AddVideos';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component

import styles from './UserDesc.scss';// to import local scss fle


class UserDesc extends Component {
  static isEmpty(val) {
    if (val) {
      return false;
    }
    return true;
  }
  static propTypes = {
    attributes: PropTypes.shape(),
    profile: PropTypes.shape(),
    video: PropTypes.shape(),
    setCurrentVideo: PropTypes.func,
    removeVideoScreen: PropTypes.func,
    removeVideo: PropTypes.func,
    public: PropTypes.string.isRequired,
    evaluationText: PropTypes.string.isRequired,
  };
  static defaultProps = {
    video: [],
    attributes: {},
    description: '',
    profile: {},
    removeVideo: () => {},
    setCurrentVideo: () => {},
    removeVideoScreen: () => {},
  };
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      seeAll: false,
    };
    this.displayVideo = this.displayVideo.bind(this);
    this.seeAll = this.seeAll.bind(this);
  }

  displayVideo(link) {
    this.props.removeVideoScreen();
    this.props.setCurrentVideo(link);
  }

  seeAll() {
    this.setState({ seeAll: true });
  }

  removeVideo = (index) => {
    const data = {
      student_id: this.props.profile.get('id'),
      video_index: index,
    };
    this.props.removeVideo(data);
  };

  render() {
    const { video, attributes, evaluationText } = this.props;
    const renderVideoButton = renderIf(!this.props.public === 'yes');
    const renderSeeAll = renderIf(video.length > 4 && !this.state.seeAll);
    const renderVideo = renderIf(video.length > 0);
    const renderEvaluationText = renderIf(evaluationText !== undefined);
    const renderdeleteButton = renderIf(this.props.public !== 'yes');
    let userIsCoach = false;
    if (this.props.attributes.size > 0) {
      if (this.props.attributes.get('zoneinfo') === 'COACH') {
        userIsCoach = true;
      }
    }
    const renderAddVideo = renderIf(attributes.size > 0 && !userIsCoach && this.props.public !== 'yes');
    let showVideos = video;
    if (!this.state.seeAll) {
      showVideos = video.slice(0, 5);
    }


    return (
      <div className={cn('row', styles.userDescContainer)}>
        {renderEvaluationText(
          <div className={styles.hideInSmall}>
            <span className={styles.blackHeader}>STUDENT EVALUATION</span>
            <div className={styles.desciption}>
              {evaluationText}<br /> <br />
            </div>
          </div>,
        )}
        {renderVideoButton(
          <AddVideo {...this.props} />,
          )}
        {renderVideo(
          <div className={cn('col s12', styles.videoheader)}>
            <span className={styles.blackHeader}>VIDEOS</span>
            <span className={styles.seeAllVideos} >
              {/* eslint-disable*/}
              {renderSeeAll(
                  <span onClick={this.seeAll}>
                   See All({video.length})
                  </span>,
              )}
              {/* eslint-enable*/}
            </span>
          </div>,
          )}


        <div className={cn('col s12', styles.videoSection)}>
          {/* eslint-disable*/}
          {showVideos.map((item, i) => (
            <div className={cn('col  s6 ', styles.videoBox)}>
              <div className={styles.video}>
                {renderdeleteButton(
                <button onClick={() => this.removeVideo(i)} className={styles.editIcon}>
                  <img src="https://media.dev.myrecruitboard.com/Images/white_delete.png" alt="edit-icon" />
                </button>
                )}
                <img className={styles.videoImage} src={item.thumbnail_url} alt="thumbnail" />
                {item.thumbnail_url && item.thumbnail_url.length > 0 &&
                item.thumbnail_url.indexOf('youtube') > -1 ?
                  <button
                    className={styles.playbutton}
                    onClick={() => this.displayVideo(item.video_url)}
                  >
                    <img className={styles.playButtonImage} src="https://media.dev.myrecruitboard.com/Images/video-icon_3%403x.png" alt="video" />

                  </button>
                      :
                  <button className={styles.playbutton} >
                    <a href={item.video_url} target="_blank" rel="noopener noreferrer" >
                      <img className={styles.playButtonImage} src="https://media.dev.myrecruitboard.com/Images/video-icon_3%403x.png" alt="video" />
                    </a>
                  </button>
                  }
                  {/* eslint-enable*/}
              </div>
              <div className={styles.titile}>{item.video_title}</div>
            </div>
                  ))}
        </div>
        <div className={cn('col s12')}>
          {renderAddVideo(
            <AddVideo {...this.props} />,
             )}

        </div>
      </div>
    );
  }
}


export default UserDesc;



// WEBPACK FOOTER //
// ./src/components/UserDesc/UserDesc.js